import _createForOfIteratorHelper from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { isValidElement, useRef, useState, useCallback, useEffect, useMemo, createContext, useContext, createElement, cloneElement } from 'react';

var isHTMLElement = value => value instanceof HTMLElement;

const EVENTS = {
  BLUR: 'blur',
  CHANGE: 'change',
  INPUT: 'input'
};
const VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
const SELECT = 'select';
const UNDEFINED = 'undefined';
const INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};

function attachEventListeners({
  ref
}, shouldAttachChangeEvent, handleChange) {
  if (isHTMLElement(ref) && handleChange) {
    ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
    ref.addEventListener(EVENTS.BLUR, handleChange);
  }
}

var isNullOrUndefined = value => value == null;

const isObjectType = value => typeof value === 'object';

var isObject = value => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !(value instanceof Date);

var isKey = value => /^\w*$/.test(value);

var compact = value => value.filter(Boolean);

var stringToPath = input => compact(input.replace(/["|']/g, '').replace(/\[/g, '.').replace(/\]/g, '').split('.'));

function set(object, path, value) {
  let index = -1;
  const tempPath = isKey(path) ? [path] : stringToPath(path);
  const length = tempPath.length;
  const lastIndex = length - 1;

  while (++index < length) {
    const key = tempPath[index];
    let newValue = value;

    if (index !== lastIndex) {
      const objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }

    object[key] = newValue;
    object = object[key];
  }

  return object;
}

var transformToNestObject = (data, value = {}) => {
  for (const key in data) {
    !isKey(key) ? set(value, key, data[key]) : value[key] = data[key];
  }

  return value;
};

var isUndefined = val => val === undefined;

var get = (obj = {}, path, defaultValue) => {
  const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};

var focusOnErrorField = (fields, fieldErrors) => {
  for (const key in fields) {
    if (get(fieldErrors, key)) {
      const field = fields[key];

      if (field) {
        if (field.ref.focus && isUndefined(field.ref.focus())) {
          break;
        } else if (field.options) {
          field.options[0].ref.focus();
          break;
        }
      }
    }
  }
};

var removeAllEventListeners = (ref, validateWithStateUpdate) => {
  if (isHTMLElement(ref) && ref.removeEventListener) {
    ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
  }
};

const defaultReturn = {
  isValid: false,
  value: null
};

var getRadioValue = options => Array.isArray(options) ? options.reduce((previous, option) => option && option.ref.checked ? {
  isValid: true,
  value: option.ref.value
} : previous, defaultReturn) : defaultReturn;

var getMultipleSelectValue = options => [...options].filter(({
  selected
}) => selected).map(({
  value
}) => value);

var isRadioInput = element => element.type === 'radio';

var isFileInput = element => element.type === 'file';

var isCheckBoxInput = element => element.type === 'checkbox';

var isMultipleSelect = element => element.type === "".concat(SELECT, "-multiple");

const defaultResult = {
  value: false,
  isValid: false
};
const validResult = {
  value: true,
  isValid: true
};

var getCheckboxValue = options => {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      const values = options.filter(option => option && option.ref.checked).map(({
        ref: {
          value
        }
      }) => value);
      return {
        value: values,
        isValid: !!values.length
      };
    }

    const _options$0$ref = options[0].ref,
          checked = _options$0$ref.checked,
          value = _options$0$ref.value,
          attributes = _options$0$ref.attributes;
    return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || value === '' ? validResult : {
      value: value,
      isValid: true
    } : validResult : defaultResult;
  }

  return defaultResult;
};

function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled, shouldKeepRawValue) {
  const field = fieldsRef.current[name];

  if (field) {
    const _field$ref = field.ref,
          value = _field$ref.value,
          disabled = _field$ref.disabled,
          ref = field.ref,
          valueAsNumber = field.valueAsNumber,
          valueAsDate = field.valueAsDate,
          setValueAs = field.setValueAs;

    if (disabled && excludeDisabled) {
      return;
    }

    if (isFileInput(ref)) {
      return ref.files;
    }

    if (isRadioInput(ref)) {
      return getRadioValue(field.options).value;
    }

    if (isMultipleSelect(ref)) {
      return getMultipleSelectValue(ref.options);
    }

    if (isCheckBoxInput(ref)) {
      return getCheckboxValue(field.options).value;
    }

    return shouldKeepRawValue ? value : valueAsNumber ? value === '' ? NaN : +value : valueAsDate ? ref.valueAsDate : setValueAs ? setValueAs(value) : value;
  }

  if (shallowFieldsStateRef) {
    return get(shallowFieldsStateRef.current, name);
  }
}

function isDetached(element) {
  if (!element) {
    return true;
  }

  if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
    return false;
  }

  return isDetached(element.parentNode);
}

var isEmptyObject = value => isObject(value) && !Object.keys(value).length;

var isBoolean = value => typeof value === 'boolean';

function baseGet(object, updatePath) {
  const length = updatePath.slice(0, -1).length;
  let index = 0;

  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }

  return object;
}

function unset(object, path) {
  const updatePath = isKey(path) ? [path] : stringToPath(path);
  const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
  const key = updatePath[updatePath.length - 1];
  let previousObjRef;

  if (childObject) {
    delete childObject[key];
  }

  for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
    let index = -1;
    let objectRef;
    const currentPaths = updatePath.slice(0, -(k + 1));
    const currentPathsLength = currentPaths.length - 1;

    if (k > 0) {
      previousObjRef = object;
    }

    while (++index < currentPaths.length) {
      const item = currentPaths[index];
      objectRef = objectRef ? objectRef[item] : object[item];

      if (currentPathsLength === index && (isObject(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter(data => isObject(data) && !isEmptyObject(data) || isBoolean(data)).length)) {
        previousObjRef ? delete previousObjRef[item] : delete object[item];
      }

      previousObjRef = objectRef;
    }
  }

  return object;
}

const isSameRef = (fieldValue, ref) => fieldValue && fieldValue.ref === ref;

function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
  const ref = field.ref,
        name = field.ref.name;
  const fieldRef = fieldsRef.current[name];

  if (!shouldUnregister) {
    const value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
    !isUndefined(value) && set(shallowFieldsStateRef.current, name, value);
  }

  if (!ref.type || !fieldRef) {
    delete fieldsRef.current[name];
    return;
  }

  if (isRadioInput(ref) || isCheckBoxInput(ref)) {
    if (Array.isArray(fieldRef.options) && fieldRef.options.length) {
      compact(fieldRef.options).forEach((option = {}, index) => {
        if (isDetached(option.ref) && isSameRef(option, option.ref) || forceDelete) {
          removeAllEventListeners(option.ref, handleChange);
          unset(fieldRef.options, "[".concat(index, "]"));
        }
      });

      if (fieldRef.options && !compact(fieldRef.options).length) {
        delete fieldsRef.current[name];
      }
    } else {
      delete fieldsRef.current[name];
    }
  } else if (isDetached(ref) && isSameRef(fieldRef, ref) || forceDelete) {
    removeAllEventListeners(ref, handleChange);
    delete fieldsRef.current[name];
  }
}

var isPrimitive = value => isNullOrUndefined(value) || !isObjectType(value);

function deepMerge(target, source) {
  if (isPrimitive(target) || isPrimitive(source)) {
    return source;
  }

  for (const key in source) {
    const targetValue = target[key];
    const sourceValue = source[key];

    try {
      target[key] = isObject(targetValue) && isObject(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? deepMerge(targetValue, sourceValue) : sourceValue;
    } catch (_a) {}
  }

  return target;
}

function deepEqual(object1, object2, isErrorObject) {
  if (isPrimitive(object1) || isPrimitive(object2) || object1 instanceof Date || object2 instanceof Date) {
    return object1 === object2;
  }

  if (!isValidElement(object1)) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
      const key = _keys[_i];
      const val1 = object1[key];

      if (!(isErrorObject && key === 'ref')) {
        const val2 = object2[key];

        if ((isObject(val1) || Array.isArray(val1)) && (isObject(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, isErrorObject) : val1 !== val2) {
          return false;
        }
      }
    }
  }

  return true;
}

function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
  let index = -1;

  while (++index < values.length) {
    for (const key in values[index]) {
      if (Array.isArray(values[index][key])) {
        !dirtyFields[index] && (dirtyFields[index] = {});
        dirtyFields[index][key] = [];
        setDirtyFields(values[index][key], get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
      } else {
        deepEqual(get(defaultValues[index] || {}, key), values[index][key]) ? set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), {
          [key]: true
        });
      }
    }

    parentNode && !dirtyFields.length && delete parentNode[parentName];
  }

  return dirtyFields;
}

var setFieldArrayDirtyFields = (values, defaultValues, dirtyFields) => deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));

var isString = value => typeof value === 'string';

var getFieldsValues = (fieldsRef, shallowFieldsState, shouldUnregister, excludeDisabled, search) => {
  const output = {};

  for (const name in fieldsRef.current) {
    if (isUndefined(search) || (isString(search) ? name.startsWith(search) : Array.isArray(search) && search.find(data => name.startsWith(data)))) {
      output[name] = getFieldValue(fieldsRef, name, undefined, excludeDisabled);
    }
  }

  return shouldUnregister ? transformToNestObject(output) : deepMerge(shallowFieldsState, transformToNestObject(output));
};

var isErrorStateChanged = ({
  errors,
  name,
  error,
  validFields,
  fieldsWithValidation
}) => {
  const isValid = isUndefined(error);
  const previousError = get(errors, name);
  return isValid && !!previousError || !isValid && !deepEqual(previousError, error, true) || isValid && get(fieldsWithValidation, name) && !get(validFields, name);
};

var isRegex = value => value instanceof RegExp;

var getValueAndMessage = validationData => isObject(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ''
};

var isFunction = value => typeof value === 'function';

var isMessage = value => isString(value) || isValidElement(value);

function getValidateError(result, ref, type = 'validate') {
  if (isMessage(result) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : '',
      ref
    };
  }
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ? Object.assign(Object.assign({}, errors[name]), {
  types: Object.assign(Object.assign({}, errors[name] && errors[name].types ? errors[name].types : {}), {
    [type]: message || true
  })
}) : {};

var validateField = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldsRef, validateAllFieldCriteria, {
    ref,
    ref: {
      value
    },
    options,
    required,
    maxLength,
    minLength,
    min,
    max,
    pattern,
    validate
  }, shallowFieldsStateRef) {
    var name, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref2, value, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, maxLengthOutput, minLengthOutput, _getValueAndMessage, patternValue, fieldValue, validateRef, result, validateError, validationResult, _i2, _Object$entries, _Object$entries$_i, key, validateFunction, validateResult;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          name = ref.name;
          error = {};
          isRadio = isRadioInput(ref);
          isCheckBox = isCheckBoxInput(ref);
          isRadioOrCheckbox = isRadio || isCheckBox;
          isEmpty = value === '';
          appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

          getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
            const message = exceedMax ? maxLengthMessage : minLengthMessage;
            error[name] = Object.assign({
              type: exceedMax ? maxType : minType,
              message,
              ref
            }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));
          };

          if (!(required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid))) {
            _context.next = 14;
            break;
          }

          _ref2 = isMessage(required) ? {
            value: !!required,
            message: required
          } : getValueAndMessage(required), value = _ref2.value, message = _ref2.message;

          if (!value) {
            _context.next = 14;
            break;
          }

          error[name] = Object.assign({
            type: INPUT_VALIDATION_RULES.required,
            message,
            ref: isRadioOrCheckbox ? ((fieldsRef.current[name].options || [])[0] || {}).ref : ref
          }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));

          if (validateAllFieldCriteria) {
            _context.next = 14;
            break;
          }

          return _context.abrupt("return", error);

        case 14:
          if (!((!isNullOrUndefined(min) || !isNullOrUndefined(max)) && value !== '')) {
            _context.next = 22;
            break;
          }

          maxOutput = getValueAndMessage(max);
          minOutput = getValueAndMessage(min);

          if (!isNaN(value)) {
            valueNumber = ref.valueAsNumber || parseFloat(value);

            if (!isNullOrUndefined(maxOutput.value)) {
              exceedMax = valueNumber > maxOutput.value;
            }

            if (!isNullOrUndefined(minOutput.value)) {
              exceedMin = valueNumber < minOutput.value;
            }
          } else {
            valueDate = ref.valueAsDate || new Date(value);

            if (isString(maxOutput.value)) {
              exceedMax = valueDate > new Date(maxOutput.value);
            }

            if (isString(minOutput.value)) {
              exceedMin = valueDate < new Date(minOutput.value);
            }
          }

          if (!(exceedMax || exceedMin)) {
            _context.next = 22;
            break;
          }

          getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

          if (validateAllFieldCriteria) {
            _context.next = 22;
            break;
          }

          return _context.abrupt("return", error);

        case 22:
          if (!(isString(value) && !isEmpty && (maxLength || minLength))) {
            _context.next = 31;
            break;
          }

          maxLengthOutput = getValueAndMessage(maxLength);
          minLengthOutput = getValueAndMessage(minLength);
          exceedMax = !isNullOrUndefined(maxLengthOutput.value) && value.length > maxLengthOutput.value;
          exceedMin = !isNullOrUndefined(minLengthOutput.value) && value.length < minLengthOutput.value;

          if (!(exceedMax || exceedMin)) {
            _context.next = 31;
            break;
          }

          getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);

          if (validateAllFieldCriteria) {
            _context.next = 31;
            break;
          }

          return _context.abrupt("return", error);

        case 31:
          if (!(isString(value) && pattern && !isEmpty)) {
            _context.next = 37;
            break;
          }

          _getValueAndMessage = getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, message = _getValueAndMessage.message;

          if (!(isRegex(patternValue) && !patternValue.test(value))) {
            _context.next = 37;
            break;
          }

          error[name] = Object.assign({
            type: INPUT_VALIDATION_RULES.pattern,
            message,
            ref
          }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));

          if (validateAllFieldCriteria) {
            _context.next = 37;
            break;
          }

          return _context.abrupt("return", error);

        case 37:
          if (!validate) {
            _context.next = 70;
            break;
          }

          fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef, false, true);
          validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;

          if (!isFunction(validate)) {
            _context.next = 51;
            break;
          }

          _context.next = 43;
          return validate(fieldValue);

        case 43:
          result = _context.sent;
          validateError = getValidateError(result, validateRef);

          if (!validateError) {
            _context.next = 49;
            break;
          }

          error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

          if (validateAllFieldCriteria) {
            _context.next = 49;
            break;
          }

          return _context.abrupt("return", error);

        case 49:
          _context.next = 70;
          break;

        case 51:
          if (!isObject(validate)) {
            _context.next = 70;
            break;
          }

          validationResult = {};
          _i2 = 0, _Object$entries = Object.entries(validate);

        case 54:
          if (!(_i2 < _Object$entries.length)) {
            _context.next = 66;
            break;
          }

          _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), key = _Object$entries$_i[0], validateFunction = _Object$entries$_i[1];

          if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
            _context.next = 58;
            break;
          }

          return _context.abrupt("break", 66);

        case 58:
          _context.next = 60;
          return validateFunction(fieldValue);

        case 60:
          validateResult = _context.sent;
          validateError = getValidateError(validateResult, validateRef, key);

          if (validateError) {
            validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));

            if (validateAllFieldCriteria) {
              error[name] = validationResult;
            }
          }

        case 63:
          _i2++;
          _context.next = 54;
          break;

        case 66:
          if (isEmptyObject(validationResult)) {
            _context.next = 70;
            break;
          }

          error[name] = Object.assign({
            ref: validateRef
          }, validationResult);

          if (validateAllFieldCriteria) {
            _context.next = 70;
            break;
          }

          return _context.abrupt("return", error);

        case 70:
          return _context.abrupt("return", error);

        case 71:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function validateField(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

const getPath = (rootPath, values, paths = []) => {
  for (const property in values) {
    const rootName = rootPath + (isObject(values) ? ".".concat(property) : "[".concat(property, "]"));
    isPrimitive(values[property]) ? paths.push(rootName) : getPath(rootName, values[property], paths);
  }

  return paths;
};

var assignWatchFields = (fieldValues, fieldName, watchFields, inputValue, isSingleField) => {
  let value = undefined;
  watchFields.add(fieldName);

  if (!isEmptyObject(fieldValues)) {
    value = get(fieldValues, fieldName);

    if (isObject(value) || Array.isArray(value)) {
      getPath(fieldName, value).forEach(name => watchFields.add(name));
    }
  }

  return isUndefined(value) ? isSingleField ? inputValue : get(inputValue, fieldName) : value;
};

var skipValidation = ({
  isOnBlur,
  isOnChange,
  isOnTouch,
  isTouched,
  isReValidateOnBlur,
  isReValidateOnChange,
  isBlurEvent,
  isSubmitted,
  isOnAll
}) => {
  if (isOnAll) {
    return false;
  } else if (!isSubmitted && isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? isReValidateOnChange : isOnChange) {
    return isBlurEvent;
  }

  return true;
};

var getFieldArrayParentName = name => name.substring(0, name.indexOf('['));

const isMatchFieldArrayName = (name, searchName) => RegExp("^".concat(searchName, "([|.)\\d+").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);

var isNameInFieldArray = (names, name) => [...names].some(current => isMatchFieldArrayName(name, current));

var isSelectInput = element => element.type === "".concat(SELECT, "-one");

function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
  const observer = new MutationObserver(() => {
    for (var _i3 = 0, _Object$values = Object.values(fieldsRef.current); _i3 < _Object$values.length; _i3++) {
      const field = _Object$values[_i3];

      if (field && field.options) {
        var _iterator = _createForOfIteratorHelper(field.options),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            const option = _step.value;

            if (option && option.ref && isDetached(option.ref)) {
              removeFieldEventListenerAndRef(field);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (field && isDetached(field.ref)) {
        removeFieldEventListenerAndRef(field);
      }
    }
  });
  observer.observe(window.document, {
    childList: true,
    subtree: true
  });
  return observer;
}

var isWeb = typeof window !== UNDEFINED && typeof document !== UNDEFINED;

function cloneObject(data) {
  var _a;

  let copy;

  if (isPrimitive(data) || isWeb && (data instanceof File || isHTMLElement(data))) {
    return data;
  }

  if (!['Set', 'Map', 'Object', 'Date', 'Array'].includes((_a = data.constructor) === null || _a === void 0 ? void 0 : _a.name)) {
    return data;
  }

  if (data instanceof Date) {
    copy = new Date(data.getTime());
    return copy;
  }

  if (data instanceof Set) {
    copy = new Set();

    var _iterator2 = _createForOfIteratorHelper(data),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        const item = _step2.value;
        copy.add(item);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return copy;
  }

  if (data instanceof Map) {
    copy = new Map();

    var _iterator3 = _createForOfIteratorHelper(data.keys()),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        const key = _step3.value;
        copy.set(key, cloneObject(data.get(key)));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return copy;
  }

  copy = Array.isArray(data) ? [] : {};

  for (const key in data) {
    copy[key] = cloneObject(data[key]);
  }

  return copy;
}

var modeChecker = mode => ({
  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
  isOnBlur: mode === VALIDATION_MODE.onBlur,
  isOnChange: mode === VALIDATION_MODE.onChange,
  isOnAll: mode === VALIDATION_MODE.all,
  isOnTouch: mode === VALIDATION_MODE.onTouched
});

var isRadioOrCheckboxFunction = ref => isRadioInput(ref) || isCheckBoxInput(ref);

const isWindowUndefined = typeof window === UNDEFINED;
const isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;

function useForm({
  mode = VALIDATION_MODE.onSubmit,
  reValidateMode = VALIDATION_MODE.onChange,
  resolver,
  context,
  defaultValues = {},
  shouldFocusError = true,
  shouldUnregister = true,
  criteriaMode
} = {}) {
  const fieldsRef = useRef({});
  const fieldArrayDefaultValuesRef = useRef({});
  const fieldArrayValuesRef = useRef({});
  const watchFieldsRef = useRef(new Set());
  const useWatchFieldsRef = useRef({});
  const useWatchRenderFunctionsRef = useRef({});
  const fieldsWithValidationRef = useRef({});
  const validFieldsRef = useRef({});
  const defaultValuesRef = useRef(defaultValues);
  const isUnMount = useRef(false);
  const isWatchAllRef = useRef(false);
  const handleChangeRef = useRef();
  const shallowFieldsStateRef = useRef({});
  const resetFieldArrayFunctionRef = useRef({});
  const contextRef = useRef(context);
  const resolverRef = useRef(resolver);
  const fieldArrayNamesRef = useRef(new Set());
  const modeRef = useRef(modeChecker(mode));
  const _modeRef$current = modeRef.current,
        isOnSubmit = _modeRef$current.isOnSubmit,
        isOnTouch = _modeRef$current.isOnTouch;
  const isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;

  const _useState = useState({
    isDirty: false,
    isValidating: false,
    dirtyFields: {},
    isSubmitted: false,
    submitCount: 0,
    touched: {},
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: !isOnSubmit,
    errors: {}
  }),
        _useState2 = _slicedToArray(_useState, 2),
        formState = _useState2[0],
        setFormState = _useState2[1];

  const readFormStateRef = useRef({
    isDirty: !isProxyEnabled,
    dirtyFields: !isProxyEnabled,
    touched: !isProxyEnabled || isOnTouch,
    isValidating: !isProxyEnabled,
    isSubmitting: !isProxyEnabled,
    isValid: !isProxyEnabled
  });
  const formStateRef = useRef(formState);
  const observerRef = useRef();
  const _useRef$current = useRef(modeChecker(reValidateMode)).current,
        isReValidateOnBlur = _useRef$current.isOnBlur,
        isReValidateOnChange = _useRef$current.isOnChange;
  contextRef.current = context;
  resolverRef.current = resolver;
  formStateRef.current = formState;
  shallowFieldsStateRef.current = shouldUnregister ? {} : isEmptyObject(shallowFieldsStateRef.current) ? cloneObject(defaultValues) : shallowFieldsStateRef.current;
  const updateFormState = useCallback((state = {}) => {
    if (!isUnMount.current) {
      formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
      setFormState(formStateRef.current);
    }
  }, []);

  const updateIsValidating = () => readFormStateRef.current.isValidating && updateFormState({
    isValidating: true
  });

  const shouldRenderBaseOnError = useCallback((name, error, shouldRender = false, state = {}, isValid) => {
    let shouldReRender = shouldRender || isErrorStateChanged({
      errors: formStateRef.current.errors,
      error,
      name,
      validFields: validFieldsRef.current,
      fieldsWithValidation: fieldsWithValidationRef.current
    });
    const previousError = get(formStateRef.current.errors, name);

    if (error) {
      unset(validFieldsRef.current, name);
      shouldReRender = shouldReRender || !previousError || !deepEqual(previousError, error, true);
      set(formStateRef.current.errors, name, error);
    } else {
      if (get(fieldsWithValidationRef.current, name) || resolverRef.current) {
        set(validFieldsRef.current, name, true);
        shouldReRender = shouldReRender || previousError;
      }

      unset(formStateRef.current.errors, name);
    }

    if (shouldReRender && !isNullOrUndefined(shouldRender) || !isEmptyObject(state) || readFormStateRef.current.isValidating) {
      updateFormState(Object.assign(Object.assign(Object.assign({}, state), resolverRef.current ? {
        isValid: !!isValid
      } : {}), {
        isValidating: false
      }));
    }
  }, []);
  const setFieldValue = useCallback((name, rawValue) => {
    const _fieldsRef$current$na = fieldsRef.current[name],
          ref = _fieldsRef$current$na.ref,
          options = _fieldsRef$current$na.options;
    const value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? '' : rawValue;

    if (isRadioInput(ref)) {
      (options || []).forEach(({
        ref: radioRef
      }) => radioRef.checked = radioRef.value === value);
    } else if (isFileInput(ref) && !isString(value)) {
      ref.files = value;
    } else if (isMultipleSelect(ref)) {
      [...ref.options].forEach(selectRef => selectRef.selected = value.includes(selectRef.value));
    } else if (isCheckBoxInput(ref) && options) {
      options.length > 1 ? options.forEach(({
        ref: checkboxRef
      }) => checkboxRef.checked = Array.isArray(value) ? !!value.find(data => data === checkboxRef.value) : value === checkboxRef.value) : options[0].ref.checked = !!value;
    } else {
      ref.value = value;
    }
  }, []);
  const isFormDirty = useCallback((name, data) => {
    if (readFormStateRef.current.isDirty) {
      const formValues = getValues();
      name && data && set(formValues, name, data);
      return !deepEqual(formValues, defaultValuesRef.current);
    }

    return false;
  }, []);
  const updateAndGetDirtyState = useCallback((name, shouldRender = true) => {
    if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
      const isFieldDirty = !deepEqual(get(defaultValuesRef.current, name), getFieldValue(fieldsRef, name, shallowFieldsStateRef));
      const isDirtyFieldExist = get(formStateRef.current.dirtyFields, name);
      const previousIsDirty = formStateRef.current.isDirty;
      isFieldDirty ? set(formStateRef.current.dirtyFields, name, true) : unset(formStateRef.current.dirtyFields, name);
      const state = {
        isDirty: isFormDirty(),
        dirtyFields: formStateRef.current.dirtyFields
      };
      const isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== get(formStateRef.current.dirtyFields, name);
      isChanged && shouldRender && updateFormState(state);
      return isChanged ? state : {};
    }

    return {};
  }, []);
  const executeValidation = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, skipReRender) {
      var error;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(process.env.NODE_ENV !== 'production')) {
              _context2.next = 4;
              break;
            }

            if (fieldsRef.current[name]) {
              _context2.next = 4;
              break;
            }

            console.warn('📋 Field is missing with `name` attribute: ', name);
            return _context2.abrupt("return", false);

          case 4:
            _context2.next = 6;
            return validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef);

          case 6:
            _context2.t0 = name;
            error = _context2.sent[_context2.t0];
            shouldRenderBaseOnError(name, error, skipReRender);
            return _context2.abrupt("return", isUndefined(error));

          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
  const executeSchemaOrResolverValidation = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(names) {
      var _yield$resolverRef$cu, errors, previousFormIsValid, isInputsValid, error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

          case 2:
            _yield$resolverRef$cu = _context3.sent;
            errors = _yield$resolverRef$cu.errors;
            previousFormIsValid = formStateRef.current.isValid;

            if (!Array.isArray(names)) {
              _context3.next = 11;
              break;
            }

            isInputsValid = names.map(name => {
              const error = get(errors, name);
              error ? set(formStateRef.current.errors, name, error) : unset(formStateRef.current.errors, name);
              return !error;
            }).every(Boolean);
            updateFormState({
              isValid: isEmptyObject(errors),
              isValidating: false
            });
            return _context3.abrupt("return", isInputsValid);

          case 11:
            error = get(errors, names);
            shouldRenderBaseOnError(names, error, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
            return _context3.abrupt("return", !error);

          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));

    return function (_x7) {
      return _ref4.apply(this, arguments);
    };
  }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
  const trigger = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name) {
      var fields, result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            fields = name || Object.keys(fieldsRef.current);
            updateIsValidating();

            if (!resolverRef.current) {
              _context5.next = 4;
              break;
            }

            return _context5.abrupt("return", executeSchemaOrResolverValidation(fields));

          case 4:
            if (!Array.isArray(fields)) {
              _context5.next = 11;
              break;
            }

            !name && (formStateRef.current.errors = {});
            _context5.next = 8;
            return Promise.all(fields.map( /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return executeValidation(data, null);

                    case 2:
                      return _context4.abrupt("return", _context4.sent);

                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));

              return function (_x9) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 8:
            result = _context5.sent;
            updateFormState({
              isValidating: false
            });
            return _context5.abrupt("return", result.every(Boolean));

          case 11:
            _context5.next = 13;
            return executeValidation(fields);

          case 13:
            return _context5.abrupt("return", _context5.sent);

          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));

    return function (_x8) {
      return _ref5.apply(this, arguments);
    };
  }(), [executeSchemaOrResolverValidation, executeValidation]);
  const setInternalValues = useCallback((name, value, {
    shouldDirty,
    shouldValidate
  }) => {
    const data = {};
    set(data, name, value);

    var _iterator4 = _createForOfIteratorHelper(getPath(name, value)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        const fieldName = _step4.value;

        if (fieldsRef.current[fieldName]) {
          setFieldValue(fieldName, get(data, fieldName));
          shouldDirty && updateAndGetDirtyState(fieldName);
          shouldValidate && trigger(fieldName);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }, [trigger, setFieldValue, updateAndGetDirtyState]);
  const setInternalValue = useCallback((name, value, config) => {
    !shouldUnregister && !isPrimitive(value) && set(shallowFieldsStateRef.current, name, Array.isArray(value) ? [...value] : Object.assign({}, value));

    if (fieldsRef.current[name]) {
      setFieldValue(name, value);
      config.shouldDirty && updateAndGetDirtyState(name);
      config.shouldValidate && trigger(name);
    } else if (!isPrimitive(value)) {
      setInternalValues(name, value, config);

      if (fieldArrayNamesRef.current.has(name)) {
        const parentName = getFieldArrayParentName(name) || name;
        set(fieldArrayDefaultValuesRef.current, name, value);
        resetFieldArrayFunctionRef.current[parentName]({
          [parentName]: get(fieldArrayDefaultValuesRef.current, parentName)
        });

        if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config.shouldDirty) {
          set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
          updateFormState({
            isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), {
              [name]: value
            }), defaultValuesRef.current)
          });
        }
      }
    }

    !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
  }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);

  const isFieldWatched = name => isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);

  const renderWatchedInputs = name => {
    let found = true;

    if (!isEmptyObject(useWatchFieldsRef.current)) {
      for (const key in useWatchFieldsRef.current) {
        if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
          useWatchRenderFunctionsRef.current[key]();
          found = false;
        }
      }
    }

    return found;
  };

  function setValue(name, value, config) {
    setInternalValue(name, value, config || {});
    isFieldWatched(name) && updateFormState();
    renderWatchedInputs(name);
  }

  handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6({
      type,
      target
    }) {
      var name, field, error, isValid, isBlurEvent, shouldSkipValidation, state, shouldRender, _yield$resolverRef$cu2, errors, previousFormIsValid, parentNodeName, currentError;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            name = target.name;
            field = fieldsRef.current[name];

            if (!field) {
              _context6.next = 31;
              break;
            }

            isBlurEvent = type === EVENTS.BLUR;
            shouldSkipValidation = skipValidation(Object.assign({
              isBlurEvent,
              isReValidateOnChange,
              isReValidateOnBlur,
              isTouched: !!get(formStateRef.current.touched, name),
              isSubmitted: formStateRef.current.isSubmitted
            }, modeRef.current));
            state = updateAndGetDirtyState(name, false);
            shouldRender = !isEmptyObject(state) || !isBlurEvent && isFieldWatched(name);

            if (isBlurEvent && !get(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
              set(formStateRef.current.touched, name, true);
              state = Object.assign(Object.assign({}, state), {
                touched: formStateRef.current.touched
              });
            }

            if (!shouldUnregister && isCheckBoxInput(target)) {
              set(shallowFieldsStateRef.current, name, getFieldValue(fieldsRef, name));
            }

            if (!shouldSkipValidation) {
              _context6.next = 12;
              break;
            }

            !isBlurEvent && renderWatchedInputs(name);
            return _context6.abrupt("return", (!isEmptyObject(state) || shouldRender && isEmptyObject(state)) && updateFormState(state));

          case 12:
            updateIsValidating();

            if (!resolverRef.current) {
              _context6.next = 25;
              break;
            }

            _context6.next = 16;
            return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

          case 16:
            _yield$resolverRef$cu2 = _context6.sent;
            errors = _yield$resolverRef$cu2.errors;
            previousFormIsValid = formStateRef.current.isValid;
            error = get(errors, name);

            if (isCheckBoxInput(target) && !error && resolverRef.current) {
              parentNodeName = getFieldArrayParentName(name);
              currentError = get(errors, parentNodeName, {});
              currentError.type && currentError.message && (error = currentError);

              if (parentNodeName && (currentError || get(formStateRef.current.errors, parentNodeName))) {
                name = parentNodeName;
              }
            }

            isValid = isEmptyObject(errors);
            previousFormIsValid !== isValid && (shouldRender = true);
            _context6.next = 29;
            break;

          case 25:
            _context6.next = 27;
            return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

          case 27:
            _context6.t0 = name;
            error = _context6.sent[_context6.t0];

          case 29:
            !isBlurEvent && renderWatchedInputs(name);
            shouldRenderBaseOnError(name, error, shouldRender, state, isValid);

          case 31:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));

    return function (_x10) {
      return _ref7.apply(this, arguments);
    };
  }();

  function setFieldArrayDefaultValues(data) {
    if (!shouldUnregister) {
      let copy = cloneObject(data);

      var _iterator5 = _createForOfIteratorHelper(fieldArrayNamesRef.current),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          const value = _step5.value;

          if (isKey(value) && !copy[value]) {
            copy = Object.assign(Object.assign({}, copy), {
              [value]: []
            });
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return copy;
    }

    return data;
  }

  function getValues(payload) {
    if (isString(payload)) {
      return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
    }

    if (Array.isArray(payload)) {
      const data = {};

      var _iterator6 = _createForOfIteratorHelper(payload),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          const name = _step6.value;
          set(data, name, getFieldValue(fieldsRef, name, shallowFieldsStateRef));
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return data;
    }

    return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister));
  }

  const validateResolver = useCallback( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(values = {}) {
      var newDefaultValues, _ref9, errors, isValid;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            newDefaultValues = isEmptyObject(fieldsRef.current) ? defaultValuesRef.current : {};
            _context7.next = 3;
            return resolverRef.current(Object.assign(Object.assign(Object.assign({}, newDefaultValues), getValues()), values), contextRef.current, isValidateAllFieldCriteria);

          case 3:
            _context7.t0 = _context7.sent;

            if (_context7.t0) {
              _context7.next = 6;
              break;
            }

            _context7.t0 = {};

          case 6:
            _ref9 = _context7.t0;
            errors = _ref9.errors;
            isValid = isEmptyObject(errors);
            formStateRef.current.isValid !== isValid && updateFormState({
              isValid
            });

          case 10:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));

    return function () {
      return _ref8.apply(this, arguments);
    };
  }(), [isValidateAllFieldCriteria]);
  const removeFieldEventListener = useCallback((field, forceDelete) => {
    findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);

    if (shouldUnregister) {
      unset(validFieldsRef.current, field.ref.name);
      unset(fieldsWithValidationRef.current, field.ref.name);
    }
  }, [shouldUnregister]);
  const updateWatchedValue = useCallback(name => {
    if (isWatchAllRef.current) {
      updateFormState();
    } else {
      var _iterator7 = _createForOfIteratorHelper(watchFieldsRef.current),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          const watchField = _step7.value;

          if (watchField.startsWith(name)) {
            updateFormState();
            break;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      renderWatchedInputs(name);
    }
  }, []);
  const removeFieldEventListenerAndRef = useCallback((field, forceDelete) => {
    if (field) {
      removeFieldEventListener(field, forceDelete);

      if (shouldUnregister && !compact(field.options || []).length) {
        unset(formStateRef.current.errors, field.ref.name);
        set(formStateRef.current.dirtyFields, field.ref.name, true);
        updateFormState({
          isDirty: isFormDirty()
        });
        readFormStateRef.current.isValid && resolverRef.current && validateResolver();
        updateWatchedValue(field.ref.name);
      }
    }
  }, [validateResolver, removeFieldEventListener]);

  function clearErrors(name) {
    name && (Array.isArray(name) ? name : [name]).forEach(inputName => fieldsRef.current[inputName] && isKey(inputName) ? delete formStateRef.current.errors[inputName] : unset(formStateRef.current.errors, inputName));
    updateFormState({
      errors: name ? formStateRef.current.errors : {}
    });
  }

  function setError(name, error) {
    const ref = (fieldsRef.current[name] || {}).ref;
    set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), {
      ref
    }));
    updateFormState({
      isValid: false
    });
    error.shouldFocus && ref && ref.focus && ref.focus();
  }

  const watchInternal = useCallback((fieldNames, defaultValue, watchId) => {
    const watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
    let fieldValues = getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, false, fieldNames);

    if (isString(fieldNames)) {
      const parentNodeName = getFieldArrayParentName(fieldNames) || fieldNames;

      if (fieldArrayNamesRef.current.has(parentNodeName)) {
        fieldValues = Object.assign(Object.assign({}, fieldArrayValuesRef.current), fieldValues);
      }

      return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(get(defaultValuesRef.current, fieldNames)) ? defaultValue : get(defaultValuesRef.current, fieldNames), true);
    }

    const combinedDefaultValues = isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;

    if (Array.isArray(fieldNames)) {
      return fieldNames.reduce((previous, name) => Object.assign(Object.assign({}, previous), {
        [name]: assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)
      }), {});
    }

    isWatchAllRef.current = isUndefined(watchId);
    return transformToNestObject(!isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
  }, []);

  function watch(fieldNames, defaultValue) {
    return watchInternal(fieldNames, defaultValue);
  }

  function unregister(name) {
    var _iterator8 = _createForOfIteratorHelper(Array.isArray(name) ? name : [name]),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        const fieldName = _step8.value;
        removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }

  function registerFieldRef(ref, options = {}) {
    if (process.env.NODE_ENV !== 'production') {
      if (!ref.name) {
        return console.warn('📋 Field is missing `name` attribute', ref, "https://react-hook-form.com/api#useForm");
      }

      if (fieldArrayNamesRef.current.has(ref.name.split(/\[\d+\]$/)[0]) && !RegExp("^".concat(ref.name.split(/\[\d+\]$/)[0], "[\\d+].\\w+").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(ref.name)) {
        return console.warn('📋 `name` prop should be in object shape: name="test[index].name"', ref, 'https://react-hook-form.com/api#useFieldArray');
      }
    }

    const name = ref.name,
          type = ref.type,
          value = ref.value;
    const fieldRefAndValidationOptions = Object.assign({
      ref
    }, options);
    const fields = fieldsRef.current;
    const isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
    const isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);

    const compareRef = currentRef => isWeb && (!isHTMLElement(ref) || currentRef === ref);

    let field = fields[name];
    let isEmptyDefaultValue = true;
    let defaultValue;

    if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && compact(field.options).find(option => {
      return value === option.ref.value && compareRef(option.ref);
    }) : compareRef(field.ref))) {
      fields[name] = Object.assign(Object.assign({}, field), options);
      return;
    }

    if (type) {
      field = isRadioOrCheckbox ? Object.assign({
        options: [...compact(field && field.options || []), {
          ref
        }],
        ref: {
          type,
          name
        }
      }, options) : Object.assign({}, fieldRefAndValidationOptions);
    } else {
      field = fieldRefAndValidationOptions;
    }

    fields[name] = field;
    const isEmptyUnmountFields = isUndefined(get(shallowFieldsStateRef.current, name));

    if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
      defaultValue = get(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
      isEmptyDefaultValue = isUndefined(defaultValue);

      if (!isEmptyDefaultValue && !isFieldArray) {
        setFieldValue(name, defaultValue);
      }
    }

    if (!isEmptyObject(options)) {
      set(fieldsWithValidationRef.current, name, true);

      if (!isOnSubmit && readFormStateRef.current.isValid) {
        validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then(error => {
          const previousFormIsValid = formStateRef.current.isValid;
          isEmptyObject(error) ? set(validFieldsRef.current, name, true) : unset(validFieldsRef.current, name);
          previousFormIsValid !== isEmptyObject(error) && updateFormState();
        });
      }
    }

    if (shouldUnregister && !(isFieldArray && isEmptyDefaultValue)) {
      !isFieldArray && unset(formStateRef.current.dirtyFields, name);
    }

    if (type) {
      attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
    }
  }

  function register(refOrRegisterOptions, options) {
    if (!isWindowUndefined) {
      if (isString(refOrRegisterOptions)) {
        registerFieldRef({
          name: refOrRegisterOptions
        }, options);
      } else if (isObject(refOrRegisterOptions) && 'name' in refOrRegisterOptions) {
        registerFieldRef(refOrRegisterOptions, options);
      } else {
        return ref => ref && registerFieldRef(ref, refOrRegisterOptions);
      }
    }
  }

  const handleSubmit = useCallback((onValid, onInvalid) => /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
      var fieldErrors, fieldValues, _yield$resolverRef$cu3, errors, values, _i4, _Object$values2, field, name, fieldError;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (e && e.preventDefault) {
              e.preventDefault();
              e.persist();
            }

            fieldErrors = {};
            fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, true));
            readFormStateRef.current.isSubmitting && updateFormState({
              isSubmitting: true
            });
            _context8.prev = 4;

            if (!resolverRef.current) {
              _context8.next = 15;
              break;
            }

            _context8.next = 8;
            return resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);

          case 8:
            _yield$resolverRef$cu3 = _context8.sent;
            errors = _yield$resolverRef$cu3.errors;
            values = _yield$resolverRef$cu3.values;
            formStateRef.current.errors = fieldErrors = errors;
            fieldValues = values;
            _context8.next = 27;
            break;

          case 15:
            _i4 = 0, _Object$values2 = Object.values(fieldsRef.current);

          case 16:
            if (!(_i4 < _Object$values2.length)) {
              _context8.next = 27;
              break;
            }

            field = _Object$values2[_i4];

            if (!field) {
              _context8.next = 24;
              break;
            }

            name = field.ref.name;
            _context8.next = 22;
            return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

          case 22:
            fieldError = _context8.sent;

            if (fieldError[name]) {
              set(fieldErrors, name, fieldError[name]);
              unset(validFieldsRef.current, name);
            } else if (get(fieldsWithValidationRef.current, name)) {
              unset(formStateRef.current.errors, name);
              set(validFieldsRef.current, name, true);
            }

          case 24:
            _i4++;
            _context8.next = 16;
            break;

          case 27:
            if (!(isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every(name => name in fieldsRef.current))) {
              _context8.next = 33;
              break;
            }

            updateFormState({
              errors: {},
              isSubmitting: true
            });
            _context8.next = 31;
            return onValid(fieldValues, e);

          case 31:
            _context8.next = 39;
            break;

          case 33:
            formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
            _context8.t0 = onInvalid;

            if (!_context8.t0) {
              _context8.next = 38;
              break;
            }

            _context8.next = 38;
            return onInvalid(formStateRef.current.errors, e);

          case 38:
            shouldFocusError && focusOnErrorField(fieldsRef.current, formStateRef.current.errors);

          case 39:
            _context8.prev = 39;
            formStateRef.current.isSubmitting = false;
            updateFormState({
              isSubmitted: true,
              isSubmitting: false,
              isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
              submitCount: formStateRef.current.submitCount + 1
            });
            return _context8.finish(39);

          case 43:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[4,, 39, 43]]);
    }));

    return function (_x11) {
      return _ref10.apply(this, arguments);
    };
  }(), [shouldFocusError, isValidateAllFieldCriteria]);

  const resetRefs = ({
    errors,
    isDirty,
    isSubmitted,
    touched,
    isValid,
    submitCount,
    dirtyFields
  }) => {
    if (!isValid) {
      validFieldsRef.current = {};
      fieldsWithValidationRef.current = {};
    }

    fieldArrayDefaultValuesRef.current = {};
    watchFieldsRef.current = new Set();
    isWatchAllRef.current = false;
    updateFormState({
      submitCount: submitCount ? formStateRef.current.submitCount : 0,
      isDirty: isDirty ? formStateRef.current.isDirty : false,
      isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
      isValid: isValid ? formStateRef.current.isValid : false,
      dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
      touched: touched ? formStateRef.current.touched : {},
      errors: errors ? formStateRef.current.errors : {},
      isSubmitting: false,
      isSubmitSuccessful: false
    });
  };

  const reset = (values, omitResetState = {}) => {
    if (isWeb) {
      for (var _i5 = 0, _Object$values3 = Object.values(fieldsRef.current); _i5 < _Object$values3.length; _i5++) {
        const field = _Object$values3[_i5];

        if (field) {
          const ref = field.ref,
                options = field.options;
          const inputRef = isRadioOrCheckboxFunction(ref) && Array.isArray(options) ? options[0].ref : ref;

          if (isHTMLElement(inputRef)) {
            try {
              inputRef.closest('form').reset();
              break;
            } catch (_a) {}
          }
        }
      }
    }

    fieldsRef.current = {};
    defaultValuesRef.current = Object.assign({}, values || defaultValuesRef.current);
    values && renderWatchedInputs('');
    Object.values(resetFieldArrayFunctionRef.current).forEach(resetFieldArray => isFunction(resetFieldArray) && resetFieldArray());
    shallowFieldsStateRef.current = shouldUnregister ? {} : cloneObject(values || defaultValuesRef.current);
    resetRefs(omitResetState);
  };

  useEffect(() => {
    resolver && readFormStateRef.current.isValid && validateResolver();
    observerRef.current = observerRef.current || !isWeb ? observerRef.current : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
  }, [removeFieldEventListenerAndRef, defaultValuesRef.current]);
  useEffect(() => () => {
    observerRef.current && observerRef.current.disconnect();
    isUnMount.current = true;

    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    Object.values(fieldsRef.current).forEach(field => removeFieldEventListenerAndRef(field, true));
  }, []);

  if (!resolver && readFormStateRef.current.isValid) {
    formState.isValid = deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && isEmptyObject(formStateRef.current.errors);
  }

  const commonProps = {
    trigger,
    setValue: useCallback(setValue, [setInternalValue, trigger]),
    getValues: useCallback(getValues, []),
    register: useCallback(register, [defaultValuesRef.current]),
    unregister: useCallback(unregister, []),
    formState: isProxyEnabled ? new Proxy(formState, {
      get: (obj, prop) => {
        if (process.env.NODE_ENV !== 'production') {
          if (prop === 'isValid' && isOnSubmit) {
            console.warn('📋 `formState.isValid` is applicable with `onTouched`, `onChange` or `onBlur` mode. https://react-hook-form.com/api#formState');
          }
        }

        if (prop in obj) {
          readFormStateRef.current[prop] = true;
          return obj[prop];
        }

        return undefined;
      }
    }) : formState
  };
  const control = useMemo(() => Object.assign({
    isFormDirty,
    updateWatchedValue,
    shouldUnregister,
    updateFormState,
    removeFieldEventListener,
    watchInternal,
    mode: modeRef.current,
    reValidateMode: {
      isReValidateOnBlur,
      isReValidateOnChange
    },
    validateResolver: resolver ? validateResolver : undefined,
    fieldsRef,
    resetFieldArrayFunctionRef,
    useWatchFieldsRef,
    useWatchRenderFunctionsRef,
    fieldArrayDefaultValuesRef,
    validFieldsRef,
    fieldsWithValidationRef,
    fieldArrayNamesRef,
    readFormStateRef,
    formStateRef,
    defaultValuesRef,
    shallowFieldsStateRef,
    fieldArrayValuesRef
  }, commonProps), [defaultValuesRef.current, updateWatchedValue, shouldUnregister, removeFieldEventListener, watchInternal]);
  return Object.assign({
    watch,
    control,
    handleSubmit,
    reset: useCallback(reset, []),
    clearErrors: useCallback(clearErrors, []),
    setError: useCallback(setError, []),
    errors: formState.errors
  }, commonProps);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const FormContext = createContext(null);
FormContext.displayName = 'RHFContext';

const useFormContext = () => useContext(FormContext);

const FormProvider = _a => {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return createElement(FormContext.Provider, {
    value: Object.assign({}, props)
  }, children);
};

var generateId = () => {
  const d = typeof performance === UNDEFINED ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

function removeAtIndexes(data, indexes) {
  let i = 0;
  const temp = [...data];

  var _iterator9 = _createForOfIteratorHelper(indexes),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      const index = _step9.value;
      temp.splice(index - i, 1);
      i++;
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  return compact(temp).length ? temp : [];
}

var removeArrayAt = (data, index) => isUndefined(index) ? [] : removeAtIndexes(data, (Array.isArray(index) ? index : [index]).sort((a, b) => a - b));

var moveArrayAt = (data, from, to) => {
  if (Array.isArray(data)) {
    if (isUndefined(data[to])) {
      data[to] = undefined;
    }

    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
  }

  return [];
};

var swapArrayAt = (data, indexA, indexB) => {
  const temp = [data[indexB], data[indexA]];
  data[indexA] = temp[0];
  data[indexB] = temp[1];
};

function prepend(data, value) {
  return [...(Array.isArray(value) ? value : [value || undefined]), ...data];
}

function insert(data, index, value) {
  return [...data.slice(0, index), ...(Array.isArray(value) ? value : [value || undefined]), ...data.slice(index)];
}

var fillEmptyArray = value => Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;

var fillBooleanArray = value => (Array.isArray(value) ? value : [value]).map(data => {
  if (isObject(data)) {
    const object = {};

    for (const key in data) {
      object[key] = true;
    }

    return object;
  }

  return true;
});

const mapIds = (values = [], keyName, skipWarn) => {
  if (process.env.NODE_ENV !== 'production') {
    if (!skipWarn) {
      var _iterator10 = _createForOfIteratorHelper(values),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          const value = _step10.value;

          if (typeof value === 'object') {
            if (keyName in value) {
              console.warn("\uD83D\uDCCB useFieldArray fieldValues contain the keyName `".concat(keyName, "` which is reserved for use by useFieldArray. https://react-hook-form.com/api#useFieldArray"));
              break;
            }
          } else {
            console.warn("\uD83D\uDCCB useFieldArray input's name should be in object shape instead of flat array. https://react-hook-form.com/api#useFieldArray");
            break;
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }

  return values.map(value => Object.assign({
    [keyName]: value[keyName] || generateId()
  }, value));
};

const useFieldArray = ({
  control,
  name,
  keyName = 'id'
}) => {
  const methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 useFieldArray is missing `control` prop. https://react-hook-form.com/api#useFieldArray');
    }
  }

  const focusIndexRef = useRef(-1);
  const isUnMount = useRef(false);

  const _ref11 = control || methods.control,
        isFormDirty = _ref11.isFormDirty,
        updateWatchedValue = _ref11.updateWatchedValue,
        resetFieldArrayFunctionRef = _ref11.resetFieldArrayFunctionRef,
        fieldArrayNamesRef = _ref11.fieldArrayNamesRef,
        fieldsRef = _ref11.fieldsRef,
        defaultValuesRef = _ref11.defaultValuesRef,
        removeFieldEventListener = _ref11.removeFieldEventListener,
        formStateRef = _ref11.formStateRef,
        shallowFieldsStateRef = _ref11.shallowFieldsStateRef,
        updateFormState = _ref11.updateFormState,
        readFormStateRef = _ref11.readFormStateRef,
        validFieldsRef = _ref11.validFieldsRef,
        fieldsWithValidationRef = _ref11.fieldsWithValidationRef,
        fieldArrayDefaultValuesRef = _ref11.fieldArrayDefaultValuesRef,
        validateResolver = _ref11.validateResolver,
        getValues = _ref11.getValues,
        shouldUnregister = _ref11.shouldUnregister,
        fieldArrayValuesRef = _ref11.fieldArrayValuesRef;

  const getDefaultValues = values => get(shouldUnregister ? values : shallowFieldsStateRef.current, name, []);

  const fieldArrayParentName = getFieldArrayParentName(name);
  const memoizedDefaultValues = useRef([...(get(fieldArrayDefaultValuesRef.current, fieldArrayParentName) ? getDefaultValues(fieldArrayDefaultValuesRef.current) : getDefaultValues(defaultValuesRef.current))]);

  const _useState3 = useState(mapIds(memoizedDefaultValues.current, keyName)),
        _useState4 = _slicedToArray(_useState3, 2),
        fields = _useState4[0],
        setFields = _useState4[1];

  set(fieldArrayValuesRef.current, name, compact(fields));

  const omitKey = fields => fields.map((_a = {}) => {
    var _b = keyName,
        omitted = _a[_b],
        rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);

    return rest;
  });

  fieldArrayNamesRef.current.add(name);
  const getFieldArrayValue = useCallback(() => get(fieldArrayValuesRef.current, name, []), [name]);

  const getCurrentFieldsValues = () => mapIds(get(getValues(), name, getFieldArrayValue()).map((item, index) => Object.assign(Object.assign({}, getFieldArrayValue()[index]), item)), keyName, true);

  fieldArrayNamesRef.current.add(name);

  if (fieldArrayParentName && !get(fieldArrayDefaultValuesRef.current, fieldArrayParentName)) {
    set(fieldArrayDefaultValuesRef.current, fieldArrayParentName, cloneObject(get(defaultValuesRef.current, fieldArrayParentName)));
  }

  const setFieldAndValidState = fieldsValues => {
    setFields(fieldsValues);
    set(fieldArrayValuesRef.current, name, fieldsValues);

    if (readFormStateRef.current.isValid && validateResolver) {
      const values = getValues();
      set(values, name, fieldsValues);
      validateResolver(values);
    }
  };

  const resetFields = () => {
    for (const key in fieldsRef.current) {
      if (isMatchFieldArrayName(key, name)) {
        removeFieldEventListener(fieldsRef.current[key], true);
        delete fieldsRef.current[key];
      }
    }
  };

  const cleanup = ref => !compact(get(ref, name, [])).length && unset(ref, name);

  const updateDirtyFieldsWithDefaultValues = updatedFieldArrayValues => {
    if (updatedFieldArrayValues) {
      set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
    }
  };

  const batchStateUpdate = (method, args, updatedFieldValues, updatedFormValues = [], shouldSet = true, shouldUpdateValid = false) => {
    if (get(shallowFieldsStateRef.current, name)) {
      const output = method(get(shallowFieldsStateRef.current, name), args.argA, args.argB);
      shouldSet && set(shallowFieldsStateRef.current, name, output);
    }

    if (get(fieldArrayDefaultValuesRef.current, name)) {
      const output = method(get(fieldArrayDefaultValuesRef.current, name), args.argA, args.argB);
      shouldSet && set(fieldArrayDefaultValuesRef.current, name, output);
    }

    if (Array.isArray(get(formStateRef.current.errors, name))) {
      const output = method(get(formStateRef.current.errors, name), args.argA, args.argB);
      shouldSet && set(formStateRef.current.errors, name, output);
      cleanup(formStateRef.current.errors);
    }

    if (readFormStateRef.current.touched && get(formStateRef.current.touched, name)) {
      const output = method(get(formStateRef.current.touched, name), args.argA, args.argB);
      shouldSet && set(formStateRef.current.touched, name, output);
      cleanup(formStateRef.current.touched);
    }

    if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
      set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFormValues), get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
      updateDirtyFieldsWithDefaultValues(updatedFieldValues);
      cleanup(formStateRef.current.dirtyFields);
    }

    if (shouldUpdateValid && readFormStateRef.current.isValid && !validateResolver) {
      set(validFieldsRef.current, name, method(get(validFieldsRef.current, name, []), args.argA));
      cleanup(validFieldsRef.current);
      set(fieldsWithValidationRef.current, name, method(get(fieldsWithValidationRef.current, name, []), args.argA));
      cleanup(fieldsWithValidationRef.current);
    }

    if (!isUnMount.current && readFormStateRef.current.isDirty) {
      updateFormState({
        isDirty: isFormDirty(name, omitKey(updatedFormValues))
      });
    }
  };

  const append = (value, shouldFocus = true) => {
    const appendValue = Array.isArray(value) ? value : [value];
    const updateFormValues = [...getCurrentFieldsValues(), ...mapIds(appendValue, keyName)];
    setFieldAndValidState(updateFormValues);

    if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
      updateDirtyFieldsWithDefaultValues(updateFormValues);
      updateFormState({
        isDirty: true,
        dirtyFields: formStateRef.current.dirtyFields
      });
    }

    !shouldUnregister && set(shallowFieldsStateRef.current, name, [...(get(shallowFieldsStateRef.current, name) || []), ...cloneObject(appendValue)]);
    focusIndexRef.current = shouldFocus ? get(fieldArrayValuesRef.current, name).length - 1 : -1;
  };

  const prepend$1 = (value, shouldFocus = true) => {
    const emptyArray = fillEmptyArray(value);
    const updatedFieldArrayValues = prepend(getCurrentFieldsValues(), mapIds(Array.isArray(value) ? value : [value], keyName));
    setFieldAndValidState(updatedFieldArrayValues);
    resetFields();
    batchStateUpdate(prepend, {
      argA: emptyArray,
      argC: fillBooleanArray(value)
    }, updatedFieldArrayValues);
    focusIndexRef.current = shouldFocus ? 0 : -1;
  };

  const remove = index => {
    const fieldValues = getCurrentFieldsValues();
    const updatedFieldValues = removeArrayAt(fieldValues, index);
    setFieldAndValidState(updatedFieldValues);
    resetFields();
    batchStateUpdate(removeArrayAt, {
      argA: index,
      argC: index
    }, updatedFieldValues, removeArrayAt(fieldValues, index), true, true);
  };

  const insert$1 = (index, value, shouldFocus = true) => {
    const emptyArray = fillEmptyArray(value);
    const fieldValues = getCurrentFieldsValues();
    const updatedFieldArrayValues = insert(fieldValues, index, mapIds(Array.isArray(value) ? value : [value], keyName));
    setFieldAndValidState(updatedFieldArrayValues);
    resetFields();
    batchStateUpdate(insert, {
      argA: index,
      argB: emptyArray,
      argC: index,
      argD: fillBooleanArray(value)
    }, updatedFieldArrayValues, insert(fieldValues, index));
    focusIndexRef.current = shouldFocus ? index : -1;
  };

  const swap = (indexA, indexB) => {
    const fieldValues = getCurrentFieldsValues();
    swapArrayAt(fieldValues, indexA, indexB);
    resetFields();
    setFieldAndValidState([...fieldValues]);
    batchStateUpdate(swapArrayAt, {
      argA: indexA,
      argB: indexB,
      argC: indexA,
      argD: indexB
    }, undefined, fieldValues, false);
  };

  const move = (from, to) => {
    const fieldValues = getCurrentFieldsValues();
    moveArrayAt(fieldValues, from, to);
    resetFields();
    setFieldAndValidState([...fieldValues]);
    batchStateUpdate(moveArrayAt, {
      argA: from,
      argB: to,
      argC: from,
      argD: to
    }, undefined, fieldValues, false);
  };

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        console.warn('📋 useFieldArray is missing `name` attribute. https://react-hook-form.com/api#useFieldArray');
      }
    }

    const defaultValues = get(fieldArrayDefaultValuesRef.current, name);

    if (defaultValues && fields.length < defaultValues.length) {
      set(fieldArrayDefaultValuesRef.current, name, defaultValues.slice(1));
    }

    updateWatchedValue(name);

    if (focusIndexRef.current > -1) {
      for (const key in fieldsRef.current) {
        const field = fieldsRef.current[key];

        if (key.startsWith("".concat(name, "[").concat(focusIndexRef.current, "]")) && field.ref.focus) {
          field.ref.focus();
          break;
        }
      }
    }

    focusIndexRef.current = -1;
  }, [fields, name]);
  useEffect(() => {
    const resetFunctions = resetFieldArrayFunctionRef.current;
    const fieldArrayNames = fieldArrayNamesRef.current;

    if (!getFieldArrayParentName(name)) {
      resetFunctions[name] = data => {
        resetFields();
        !data && unset(fieldArrayDefaultValuesRef.current, name);
        unset(shallowFieldsStateRef.current, name);
        memoizedDefaultValues.current = get(data || defaultValuesRef.current, name);

        if (!isUnMount.current) {
          setFields(mapIds(memoizedDefaultValues.current, keyName));
        }
      };
    }

    return () => {
      isUnMount.current = true;
      shouldUnregister && remove();
      resetFields();
      delete resetFunctions[name];
      unset(fieldArrayValuesRef.current, name);
      fieldArrayNames.delete(name);
    };
  }, []);
  return {
    swap: useCallback(swap, [name]),
    move: useCallback(move, [name]),
    prepend: useCallback(prepend$1, [name]),
    append: useCallback(append, [name]),
    remove: useCallback(remove, [name]),
    insert: useCallback(insert$1, [name]),
    fields: compact(fields)
  };
};

var getInputValue = event => isPrimitive(event) || !isObject(event.target) || isObject(event.target) && !event.type ? event : isUndefined(event.target.value) ? event.target.checked : event.target.value;

function useController({
  name,
  rules,
  defaultValue,
  control,
  onFocus
}) {
  const methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 Controller is missing `control` prop. https://react-hook-form.com/api#Controller');
    }
  }

  const _ref12 = control || methods.control,
        defaultValuesRef = _ref12.defaultValuesRef,
        setValue = _ref12.setValue,
        register = _ref12.register,
        unregister = _ref12.unregister,
        trigger = _ref12.trigger,
        mode = _ref12.mode,
        _ref12$reValidateMode = _ref12.reValidateMode,
        isReValidateOnBlur = _ref12$reValidateMode.isReValidateOnBlur,
        isReValidateOnChange = _ref12$reValidateMode.isReValidateOnChange,
        formState = _ref12.formState,
        _ref12$formStateRef$c = _ref12.formStateRef.current,
        isSubmitted = _ref12$formStateRef$c.isSubmitted,
        touched = _ref12$formStateRef$c.touched,
        errors = _ref12$formStateRef$c.errors,
        updateFormState = _ref12.updateFormState,
        readFormStateRef = _ref12.readFormStateRef,
        fieldsRef = _ref12.fieldsRef,
        fieldArrayNamesRef = _ref12.fieldArrayNamesRef,
        shallowFieldsStateRef = _ref12.shallowFieldsStateRef;

  const isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);

  const getInitialValue = () => !isUndefined(get(shallowFieldsStateRef.current, name)) && isNotFieldArray ? get(shallowFieldsStateRef.current, name) : isUndefined(defaultValue) ? get(defaultValuesRef.current, name) : defaultValue;

  const _useState5 = useState(getInitialValue()),
        _useState6 = _slicedToArray(_useState5, 2),
        value = _useState6[0],
        setInputStateValue = _useState6[1];

  const valueRef = useRef(value);
  const ref = useRef({
    focus: () => null
  });
  const onFocusRef = useRef(onFocus || (() => {
    if (isFunction(ref.current.focus)) {
      ref.current.focus();
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!isFunction(ref.current.focus)) {
        console.warn("\uD83D\uDCCB 'ref' from Controller render prop must be attached to a React component or a DOM Element whose ref provides a 'focus()' method");
      }
    }
  }));
  const shouldValidate = useCallback(isBlurEvent => !skipValidation(Object.assign({
    isBlurEvent,
    isReValidateOnBlur,
    isReValidateOnChange,
    isSubmitted,
    isTouched: !!get(touched, name)
  }, mode)), [isReValidateOnBlur, isReValidateOnChange, isSubmitted, touched, name, mode]);
  const commonTask = useCallback(([event]) => {
    const data = getInputValue(event);
    setInputStateValue(data);
    valueRef.current = data;
    return data;
  }, []);
  const registerField = useCallback(shouldUpdateValue => {
    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        return console.warn('📋 Field is missing `name` prop. https://react-hook-form.com/api#Controller');
      }
    }

    if (fieldsRef.current[name]) {
      fieldsRef.current[name] = Object.assign({
        ref: fieldsRef.current[name].ref
      }, rules);
    } else {
      register(Object.defineProperties({
        name,
        focus: onFocusRef.current
      }, {
        value: {
          set(data) {
            setInputStateValue(data);
            valueRef.current = data;
          },

          get() {
            return valueRef.current;
          }

        }
      }), rules);
      shouldUpdateValue = isUndefined(get(defaultValuesRef.current, name));
    }

    shouldUpdateValue && isNotFieldArray && setInputStateValue(getInitialValue());
  }, [rules, name, register]);
  useEffect(() => () => unregister(name), [name]);
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (isUndefined(value)) {
        console.warn("\uD83D\uDCCB ".concat(name, " is missing in the 'defaultValue' prop of either its Controller (https://react-hook-form.com/api#Controller) or useForm (https://react-hook-form.com/api#useForm)"));
      }

      if (!isNotFieldArray && isUndefined(defaultValue)) {
        console.warn('📋 Controller is missing `defaultValue` prop when using `useFieldArray`. https://react-hook-form.com/api#Controller');
      }
    }

    registerField();
  }, [registerField]);
  useEffect(() => {
    !fieldsRef.current[name] && registerField(true);
  });
  const onBlur = useCallback(() => {
    if (readFormStateRef.current.touched && !get(touched, name)) {
      set(touched, name, true);
      updateFormState({
        touched
      });
    }

    shouldValidate(true) && trigger(name);
  }, [name, updateFormState, shouldValidate, trigger, readFormStateRef]);
  const onChange = useCallback((...event) => setValue(name, commonTask(event), {
    shouldValidate: shouldValidate(),
    shouldDirty: true
  }), [setValue, name, shouldValidate]);
  return {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    meta: Object.defineProperties({
      invalid: !!get(errors, name)
    }, {
      isDirty: {
        get() {
          return !!get(formState.dirtyFields, name);
        }

      },
      isTouched: {
        get() {
          return !!get(formState.touched, name);
        }

      }
    })
  };
}

function useWatch({
  control,
  name,
  defaultValue
}) {
  const methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 useWatch is missing `control` prop. https://react-hook-form.com/api#useWatch');
    }
  }

  const _ref13 = control || methods.control,
        useWatchFieldsRef = _ref13.useWatchFieldsRef,
        useWatchRenderFunctionsRef = _ref13.useWatchRenderFunctionsRef,
        watchInternal = _ref13.watchInternal,
        defaultValuesRef = _ref13.defaultValuesRef;

  const updateValue = useState()[1];
  const idRef = useRef();
  const defaultValueRef = useRef(defaultValue);
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (name === '') {
        console.warn('📋 useWatch is missing `name` attribute. https://react-hook-form.com/api#useWatch');
      }
    }

    const id = idRef.current = generateId();
    const watchFieldsHookRender = useWatchRenderFunctionsRef.current;
    const watchFieldsHook = useWatchFieldsRef.current;
    watchFieldsHook[id] = new Set();

    watchFieldsHookRender[id] = () => updateValue({});

    watchInternal(name, defaultValueRef.current, id);
    return () => {
      delete watchFieldsHook[id];
      delete watchFieldsHookRender[id];
    };
  }, [name, useWatchRenderFunctionsRef, useWatchFieldsRef, watchInternal, defaultValueRef]);
  return idRef.current ? watchInternal(name, defaultValueRef.current, idRef.current) : isUndefined(defaultValue) ? isString(name) ? get(defaultValuesRef.current, name) : Array.isArray(name) ? name.reduce((previous, inputName) => Object.assign(Object.assign({}, previous), {
    [inputName]: get(defaultValuesRef.current, inputName)
  }), {}) : defaultValuesRef.current : defaultValue;
}

const Controller = props => {
  const rules = props.rules,
        as = props.as,
        render = props.render,
        defaultValue = props.defaultValue,
        control = props.control,
        onFocus = props.onFocus,
        rest = __rest(props, ["rules", "as", "render", "defaultValue", "control", "onFocus"]);

  const _useController = useController(props),
        field = _useController.field,
        meta = _useController.meta;

  const componentProps = Object.assign(Object.assign({}, rest), field);
  return as ? isValidElement(as) ? cloneElement(as, componentProps) : createElement(as, componentProps) : render ? render(field, meta) : null;
};

export { Controller, FormProvider, appendErrors, get, transformToNestObject, useController, useFieldArray, useForm, useFormContext, useWatch };